module.exports = "<p style=\"margin:0\" class=\"text-center\">\n  {{message}}\n</p>"